const PopUpDialog = ({
    show,
    closeAction,
    title,
    className = "",
    body = null,
    footer = null
}) => {
    if (!show) return null;

    const onClose = () => {
        if (typeof closeAction === "function") {
            closeAction();
        }
    };

    return (
        <>
            <div
                className={`modal fade show ${className}`}
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
                style={{ display: "block" }}
            >
                <div className="modal-dialog modal-dialog-scrollable modal-lg">
                    <div className="modal-content">
                        <div className="modal-header d-flex align-items-center">
                            <h4 className="modal-title">{title}</h4>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            />
                        </div>
                        <div className="modal-body">{body}</div>
                        {footer ? (
                            <div className="modal-footer">{footer}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" onClick={onClose} />
        </>
    );
};

export default PopUpDialog;
